import Ws, { Connection } from '@adonisjs/websocket-client'
import { useEffect, useRef, useState } from 'react'

const WS_URL = import.meta.env.VITE_WS_API
const isValidWsUrl = typeof WS_URL === 'string' && /^wss?:\/\//.test(WS_URL)

export default function useAppWebsocket ({
  authToken = null,
}: {
  authToken?: string | null
} = {}) {
  const websocket = useRef<Connection | null>(null)
  const [ ready, setReady ] = useState(false)

  useEffect(() => {
    if (!isValidWsUrl) {
      console.warn('[useAppWebsocket] Invalid websocket url. Check VITE_WS_API env var.')
      return () => {
        setReady(false)
      }
    }

    if (!websocket.current && isValidWsUrl && WS_URL) {
      const socket = Ws(WS_URL)

      if (authToken) {
        socket.withJwtToken(authToken)
      }

      socket.connect()

      socket.on('open', () => {
        setReady(true)
      })
      socket.on('close', () => {
        setReady(false)
      })

      websocket.current = socket
    }

    return () => {
      if (websocket.current) {
        try {
          websocket.current.close()
        }
        catch (error) {
          console.warn('[useAppWebsocket] Error closing websocket:', error)
        }
        finally {
          websocket.current = null
        }
      }

      setReady(false)
    }
  }, [ authToken ])

  return {
    socket: websocket.current,
    ready,
  }
}
